/** Bảng nhiệm vụ M3: NV hằng ngày (5, reset 0h giờ máy) + đơn lớn có thời hạn. */
import { hangThieuDonLon, mauDonLonMo } from '../../core/nhiem-vu.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, styleNutChinh, stylePanel, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

function tenLoaiMucTieu(loai: string): string {
  switch (loai) {
    case 'banMonNhom':
      return 'Bán món nhóm';
    case 'phucVuKieuKhach':
      return 'Phục vụ';
    case 'doanhThu':
      return 'Doanh thu';
    case 'banCaPhe':
      return 'Bán cà phê';
    default:
      return loai;
  }
}

export function PanelNhiemVu(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const mauNv = new Map(duLieu.nhiemVu.nhiemVuHangNgay.map((m) => [m.ma, m]));
  const ndNv = new Map(duLieu.noiDungNhiemVu.map((n) => [n.ma, n]));
  const ndDl = new Map(duLieu.noiDungDonLon.map((n) => [n.ma, n]));

  const bamNhanDon = (): void => {
    try {
      controller.nhanDonLon();
      toast('Đã nhận đơn lớn! 📦');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không nhận được.');
    }
  };

  const bamGiaoDon = (): void => {
    try {
      const kq = controller.giaoDonLon();
      toast(`Giao đơn xong! +${dinhDangXu(kq.xu)}, +${kq.xuCaoCap} xu cao cấp, +${kq.xp} XP 🎉`);
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không giao được.');
    }
  };

  const don = state.donLon;
  const thieu = don && don.daChapNhan ? hangThieuDonLon(state, duLieu) : [];

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>📋 Nhiệm vụ hằng ngày</h3>
      <p style={{ margin: '0 0 8px', fontSize: '13px', opacity: 0.85 }}>
        5 nhiệm vụ mỗi ngày máy (reset 0 giờ). Hoàn thành để nhận xu + XP.
      </p>
      {state.nhiemVu.length === 0 && (
        <p style={{ fontSize: '13px', opacity: 0.7 }}>Chưa có nhiệm vụ hôm nay.</p>
      )}
      {state.nhiemVu.map((nv) => {
        const mau = mauNv.get(nv.ma);
        if (!mau) return null;
        const pct = Math.min(100, Math.round((nv.tienDo / mau.soLuong) * 100));
        return (
          <div
            key={nv.ma}
            style={{
              border: '1px solid #8a6a3a',
              borderRadius: '8px',
              padding: '8px',
              marginBottom: '6px',
              opacity: nv.hoanThanh ? 0.6 : 1,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: '14px' }}>
              {nv.hoanThanh ? '✅ ' : ''}
              {ndNv.get(nv.ma)?.ten ?? tenLoaiMucTieu(mau.loaiMucTieu)} ({Math.floor(nv.tienDo)}/
              {mau.soLuong})
            </div>
            <div style={{ fontSize: '12px', opacity: 0.8 }}>{ndNv.get(nv.ma)?.moTa}</div>
            <div
              style={{
                height: '6px',
                background: '#3a2c18',
                borderRadius: '3px',
                marginTop: '4px',
              }}
            >
              <div
                style={{
                  width: `${pct}%`,
                  height: '100%',
                  background: '#c98a2e',
                  borderRadius: '3px',
                }}
              />
            </div>
            <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '2px' }}>
              Thưởng: {dinhDangXu(mau.thuongXu)} + {mau.thuongXp} XP
            </div>
          </div>
        );
      })}

      <h3 style={{ margin: '12px 0 8px' }}>📦 Đơn lớn</h3>
      {!don && (
        <p style={{ fontSize: '13px', opacity: 0.7 }}>
          Đơn lớn xuất hiện ngẫu nhiên (người chơi cấp 2+). Nhận và giao đúng hạn để được xu cao
          cấp.
        </p>
      )}
      {don && (
        <div style={{ border: '1px solid #c98a2e', borderRadius: '8px', padding: '8px' }}>
          <div style={{ fontWeight: 700 }}>{ndDl.get(don.ma)?.ten ?? don.ma}</div>
          <div style={{ fontSize: '12px', opacity: 0.8 }}>{ndDl.get(don.ma)?.moTa}</div>
          <div style={{ fontSize: '13px' }}>
            Cần:{' '}
            {Object.entries(don.yeuCau)
              .map(([ma, sl]) => `${ma}×${sl}`)
              .join(', ')}
          </div>
          <div style={{ fontSize: '13px' }}>Còn {don.hanConLai} giờ game</div>
          {thieu.length > 0 && (
            <div style={{ fontSize: '13px', color: '#e08a8a' }}>
              Thiếu: {thieu.map((t) => `${t.ma} (cần ${t.can}, có ${t.co})`).join(', ')}
            </div>
          )}
          <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
            {!don.daChapNhan && (
              <button style={styleNutChinh} onClick={bamNhanDon}>
                Nhận đơn
              </button>
            )}
            {don.daChapNhan && (
              <button style={styleNutChinh} onClick={bamGiaoDon}>
                Giao đơn
              </button>
            )}
          </div>
        </div>
      )}
      <p style={{ fontSize: '12px', opacity: 0.7, marginTop: '8px' }}>
        Mẫu đơn mở: {mauDonLonMo(state, duLieu).length} loại.
      </p>
    </div>
  );
}
